export default __webpack_public_path__ + "static/media/terre.7faa80c6.png";